module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Flag-410f6213f28d055d5b11562f03451681.svg";